define((require) => {
    "use strict";

    const CustomJsAction            = require("shared/ui/experience/action/customJs/CustomJsAction");
    const SalesforceCommerceQuickViewAction = require("shared/ui/experience/widgets/salesforceCommerceWidget/action/SalesforceCommerceQuickViewAction");
    const Enum                      = require("shared/util/Enum");
    const JsAction                  = require("shared/ui/experience/action/js/JsAction");
    const LightboxAction            = require("shared/ui/experience/action/lightbox/LightboxAction");
    const LinkAction                = require("shared/ui/experience/action/link/LinkAction");
    const ProductCustomJsAction     = require("shared/ui/experience/action/product/ProductCustomJsAction");
    const ProductLightboxAction     = require("shared/ui/experience/action/product/ProductLightboxAction");
    const ProductLinkAction         = require("shared/ui/experience/action/product/ProductLinkAction");
    const SceneNavigationAction     = require("shared/ui/experience/action/sceneNavigation/SceneNavigationAction");

    /**
     * A enum describing all modelled action types, where each type can have numerous instances. <p>
     *
     * The returned enum will index each action type via is static defined <tt>TYPE</tt> property, e.g.
     * {.., LinkAction.TYPE: LinkAction, ..}, where the described value of the key in this example is
     * "link".
     */
    return Enum.create("Action", "TYPE", [
        CustomJsAction,
        SalesforceCommerceQuickViewAction,
        JsAction,
        LightboxAction,
        LinkAction,
        ProductCustomJsAction,
        ProductLightboxAction,
        ProductLinkAction,
        SceneNavigationAction
    ]);
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/Actions.js